import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import {
  Box,
  TextField,
  Grid,
  Button,
  CircularProgress,
  Switch,
  FormControlLabel,
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import dayjs from "dayjs";
import { useSnackbar } from "src/components/snackbar/useSnackbar";
import { authenticationService } from "src/services/authentication.service";
import { get,put } from 'src/services/httpClient.service';

const Updatecompany = () => {
  const { id } = useParams();
  const navigate = useNavigate()
  const { showSnackbar } = useSnackbar();
  const APIURL = process.env.REACT_APP_BASE_API_URL;
  const { vendorId } = authenticationService.getVendorFranchiseIds();

  const [loading, setLoading] = useState(false);
  const [zonelist, setZoneList] = useState([]);

  const [formData, setFormData] = useState<any>({
    companyName: "",
    email: "",
    mobileNo: "",
    createdOn: dayjs().format("YYYY-MM-DDTHH:mm"),
    status: true,
    address1: "",
    address2: "",
    //address3: "",
    slogan: "",
    logo: "",
    //country: "",
    //state: "",
    zone: "",
    //city: "",
    tinNo: "",
    panNo: "",
    serviceTaxNo: "",
    entertainmentTaxNo: "",
    cstNo: "",
    website: "",
    operatorname: "",
    operatorCode: "",
    areaOfOperation: "",
    gstNo: "",
    aadharNo: "",
    customerDocumentSavePath: "",
    franchiseDocumentSavePath: "",
    liveUrlLogoPathForEmail: "",
    areaId: "",
    areaName:"",
    vendorId:vendorId
  });

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [loadingCities, setLoadingCities] = useState(false);
  const [areaList, setAreaList] = React.useState([]);
  const [selectedBillingAreaId, setSelectedBillingAreaId] = React.useState('');

  // -----------------------
  // Fetch States
  // -----------------------
  /* const fetchStates = async () => {
    try {
      const res = await get(`${APIURL}/states`);
      setStates(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Error loading states", err);
    }
  }; */

  // -----------------------
  // Fetch Cities
  // -----------------------
  /* const fetchCities = async (stateName: string) => {
    if (!stateName) return setCities([]);

    setLoadingCities(true);
    try {
      const res = await get(`${APIURL}/cities?stateName=${encodeURIComponent(stateName)}`);
      setCities(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Error loading cities", err);
    } finally {
      setLoadingCities(false);
    }
  }; */

  // -----------------------
  // Load company data by ID
  // -----------------------
  const fetchCompanyById = async () => {
    try {
      const res = await get(`${APIURL}/api/company/vendor/${vendorId}/fetchAll`);
      const list = Array.isArray(res) ? res : res;

      const filtered = list.find((item) => item.id === id);
       
      if (filtered) {
        setFormData({
          ...filtered,
          createdOn: filtered.createdOn
            ? dayjs(filtered.createdOn).format("YYYY-MM-DDTHH:mm")
            : "",
        });

        // load cities default
        //if (filtered.state) fetchCities(filtered.state);
      }
    } catch (err) {
      console.error("Error fetching company", err);
    }
  };

  const fetchAreas = async () => {
              try {
                const response = await get(
                  `${APIURL}/api/miscellaneous/area/vendor/${vendorId}/findAll`
                );
                if (response) setAreaList(response?.data);
                console.log('city',response?.data)
              } catch (error) {
                console.error("Error fetching areas", error);
              }
            };
      
            React.useEffect(() => {
                  fetchAreas();
                }, []);

  // -----------------------
  // Load initial data
  // -----------------------
  useEffect(() => {
    /* fetchStates(); */
    fetchCompanyById();
  }, [id]);

   const handlezonelist = async () => {
    
        try {
    
          const response = await get(`${APIURL}/api/miscellaneous/zone/vendor/${vendorId}/findAll`)
          console.log('zone', response?.data)
          setZoneList(response?.data)
    
        } catch (error) {
          console.log("zonelist", error)
        }
    
      }

      useEffect(()=>{
        handlezonelist()
      },[])
  

  // -----------------------
  // Handle Input Change
  // -----------------------
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({ ...prev, [name]: value }));
  };

  const handleStatusChange = (e: any) => {
    setFormData((prev: any) => ({ ...prev, status: e.target.checked }));
  };

  // -----------------------
  // Submit Update API
  // -----------------------
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await put(`${APIURL}/api/company/${id}`, formData);
      console.log('res',res)
      if (res) {
        showSnackbar("Company updated successfully!", "success");
        navigate('/company/Company')
      } else {
        showSnackbar("Failed to update company.", "error");
      }
    } catch (err) {
      showSnackbar("Error updating company.", "error");
      console.error("Update error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2, padding: 3 }}>
      <Grid container spacing={2}>
        {/* --- 2 per row fields below --- */}

        <Grid item xs={12} md={6}>
          <TextField fullWidth label="Company Name" name="companyName" value={formData.companyName} onChange={handleChange} />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField fullWidth type="email" label="Email" name="email" value={formData.email} onChange={handleChange} />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField fullWidth label="Mobile No" name="mobileNo" value={formData.mobileNo} onChange={handleChange} />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField fullWidth type="datetime-local"  name="createdOn" value={formData.createdOn} onChange={handleChange} />
        </Grid>

        

        {/* addresses */}
        <Grid item xs={12} md={6}>
          <TextField fullWidth label="Address" name="address1" value={formData.address1} onChange={handleChange} />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField fullWidth label="Landmark/Village" name="address2" value={formData.address2} onChange={handleChange} />
        </Grid>

        {/* <Grid item xs={12} md={6}>
          <TextField fullWidth label="Address 3" name="address3" value={formData.address3} onChange={handleChange} />
        </Grid> */}

        {/* slogan + logo */}
        <Grid item xs={12} md={6}>
          <TextField fullWidth label="Slogan" name="slogan" value={formData.slogan} onChange={handleChange} />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField fullWidth label="Logo URL" name="logo" value={formData.logo} onChange={handleChange} />
        </Grid>

        {/* country */}
       {/*  <Grid item xs={12} md={6}>
          <TextField select fullWidth  name="country" value={formData.country} onChange={handleChange} SelectProps={{ native: true }}>
            <option value="">Select Country</option>
            <option value="India">India</option>
          </TextField>
        </Grid> */}

        {/* state */}
        {/* <Grid item xs={12} md={6}>
          <TextField
            select
            fullWidth
        
            name="state"
            value={formData.state}
            SelectProps={{ native: true }}
            onChange={(e) => {
              handleChange(e);
              fetchCities(e.target.value);
            }}
          >
            <option value="">Select State</option>
            {states.map((s: any, i: number) => (
              <option key={i} value={s}>
                {s}
              </option>
            ))}
          </TextField>
        </Grid> */}

        {/* city */}
        {/* <Grid item xs={12} md={6}>
          <TextField
            select
            fullWidth
        
            name="city"
            value={formData.city}
            SelectProps={{ native: true }}
            disabled={!formData.state}
            onChange={handleChange}
          >
            <option value="">Select City</option>
            {loadingCities ? <option>Loading...</option> : cities.map((c: any, i: number) => (
              <option key={i} value={c.cityName || c}>
                {c.cityName || c}
              </option>
            ))}
          </TextField>
        </Grid> */}

        <Grid item xs={6} >
                  <Autocomplete
                    options={areaList}
                    loading={!areaList.length}
        
                    value={
                      areaList.find(
                        (a) => String(a.id) === String(formData.areaId)
                      ) ?? null
                    }
        
                    getOptionLabel={(option) =>
                      `${option.name} / ${option.cityName} / ${option.stateName} / ${option.countryName} / ${option.zipCode}`
                    }
        
                    isOptionEqualToValue={(option, value) =>
                      String(option.id) === String(value.id)
                    }
        
                    onChange={(_, newValue) => {
                      setFormData((prev) => ({
                        ...prev,
                        areaId: newValue ? newValue.id : '',
                        areaName: newValue ? newValue.cityName : ''
                      }));
                      console.log('newValue', newValue)
                    }}
        
                    inputValue={selectedBillingAreaId}
                    onInputChange={(_, newInputValue) =>
                      setSelectedBillingAreaId(newInputValue)
        
                    }
        
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Area (City)"
                        fullWidth
                        //error={!!errors.areaId}
                        //helperText={errors.areaId}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {!areaList.length && <CircularProgress size={18} />}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>

        {/* zone */}
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel>Zone</InputLabel>
            <Select
            name="zone"
            value={formData.zone}
            label='Zone'
            onChange={handleChange}
            >
              <MenuItem vocab="">Select Zone</MenuItem>
              {
                zonelist.map((zone)=>(
                  <MenuItem key={zone.id} value={zone.name}>
                    {zone.name}
                  </MenuItem>
                ))
              }
              <MenuItem></MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {/* remaining fields — same pattern */}
        {[
          "tinNo",
          "panNo",
          "serviceTaxNo",
          "entertainmentTaxNo",
          "cstNo",
          "website",
          "operatorname",
          "operatorCode",
          "areaOfOperation",
          "gstNo",
          "aadharNo",
          "customerDocumentSavePath",
          "franchiseDocumentSavePath",
          "liveUrlLogoPathForEmail",
        ].map((field) => (
          <Grid item xs={12} md={6} key={field}>
            <TextField
              fullWidth
              label={field.replace(/([A-Z])/g, " $1")}
              name={field}
              value={formData[field] || ""}
              onChange={handleChange}
            />
          </Grid>
        ))}

        {/* Status */}
        <Grid item xs={12} md={6}>
          <FormControlLabel
            control={<Switch checked={formData.status} onChange={handleStatusChange} color="primary" />}
            label={formData.status ? "Active" : "Inactive"}
          />
        </Grid>

        {/* Submit */}
        <Grid item xs={12}>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
            <Button variant="outlined" sx={{ mr: 2 }} onClick={(()=>navigate('/company/Company'))}>
                      Cancel
            </Button>
            <Button variant="contained" type="submit" disabled={loading}>
              {loading ? <CircularProgress size={24} /> : "Update Company"}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Updatecompany;
